import { __export } from "./chunk-QK4PKNB3.mjs"; // src/constants/slack.ts

var slack_exports = {};

__export(slack_exports, {
  slackID: function slackID() {
    return _slackID;
  }
});

var _slackID = {
  mike: "U078E1VP75Z",
  paul: "U04RS43S8KV",
  grace: "U04RBMG9PLP",
  jerry: "U0838RNK5TN",
  maxine: "U08BEAV9D42",
  leslie: "U04N4U6NW",
  charlie: "U07CBPXDL",
  shunwen: "U070VB43E6S",
  jimmy: "U07RGSLJQR4",
  tim: "U07R0DU5A9X"
};
export { _slackID as slackID, slack_exports };